import React, { Component } from 'react';
import _memoize from 'lodash.memoize';
import { notify } from '../../../../Notifications';
import ArchiveConfirmationModal from '../../../../ConfirmationModal';
import CONFIRM_ACTION from '../constants/confirmActions';

function getSubtitle(text, organisationName) {
  return (
    <span>
      {text}
      <strong>{organisationName}</strong>
      .
    </span>);

}
















class ConfirmationModal extends Component {
  handleActionRequest = _memoize((actionRequest) => async () => {
    const { assetId, onConfirmation, hideModal } = this.props;

    const { data, error } = await actionRequest(assetId);

    if (!data || error) {
      return notify({
        content: error,
        type: 'error'
      });
    }

    onConfirmation();

    return hideModal();
  });

  getModalProps = () => {
    const { confirmModalAction, archiveAsset, unarchiveAsset, organisationName } = this.props;

    switch (confirmModalAction) {
      case CONFIRM_ACTION.ARCHIVE:
        return {
          onSave: this.handleActionRequest(archiveAsset),
          subtitle: getSubtitle('Archiving this asset will make this hidden from view from everyone within ', organisationName)
        };
      case CONFIRM_ACTION.UNARCHIVE:
        return {
          onSave: this.handleActionRequest(unarchiveAsset),
          subtitle: getSubtitle('Unarchiving this asset will make this visible for everyone within ', organisationName)
        };
      default:
        return {};
    }
  };

  render() {
    const { visible, hideModal, confirmModalAction } = this.props;

    return (
      <ArchiveConfirmationModal
        visible={visible && confirmModalAction !== CONFIRM_ACTION.DELETE}
        onClose={hideModal}
        title="Are you sure?"
        saveBtnText="Continue"
        {...this.getModalProps()} />);


  }
}

export default ConfirmationModal;